import {Component, ViewChild, ElementRef, ViewEncapsulation, AfterViewInit, OnInit, Inject} from '@angular/core';
// import {VERSION} from '@angular/material';
import {NavList} from '../shared/models/navlist.model';
import {NavService} from '../shared/services/nav.service';
import { CommonService } from '../shared/services/common.service';
import {Subscription} from 'rxjs'
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { isNgTemplate } from '@angular/compiler';
import { Collapse } from '@dds-uicore/all';
import * as UIC from '@dds-uicore/all';
import { AuthService } from '../shared/services/auth.service';
import { GlobalConstants } from '../shared/global-constants';
import { CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';

export interface DialogData {
  folder: string;
  parentFolder:string;
  mode:string;
  item: any;
  duplictatefileNameMessage: any;
  activeFilesCount:any;
  navItemType:string;
  isEmptyFile:boolean;
  isEmptyFolder:boolean;
}

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SidenavComponent implements AfterViewInit, OnInit {
  folderName:string;
  prevUrl:string;
  parentFolder:string;
  mode:string="default";
  navItems:NavList[]=[];
  private navSub: Subscription;
  newUrl: string;
  private urlOfMatListClicked:string;
  RoleName: any;
  Moderator = GlobalConstants.Moderator;
  Publisher = GlobalConstants.Publisher;
  dloUser = GlobalConstants.dloUser;
  result: any;
  filesChecked = [];
  selectedIds = [];
  selectedFiles = [];
  filesIdsNamesList = [];
  duplicateFoldersList = [];
  duplicatefolderErrorsMessage = "";
  tempArray:any=[];
  loading: boolean;
  parameters: any;
  processingLogin: boolean;
  isEmptyFolder:boolean=false;
  isEmptyFile:boolean=false;
  isFolderHaveFiles:boolean=true;
  constructor(private navService: NavService,private authService: AuthService,private route: ActivatedRoute,
    private commonService:CommonService, private router:Router,public dialog: MatDialog) {
      this.navService.invokeEvent.subscribe(value => {
        if(value.type=='new_folder' || value.type == 'new_file')
            this.openDialog(value.type,value.item);
        else if(value.type==='delete')
            {
              this.openDialogDelete(value.item)
            }
        else if (value.type=='edit')
            this.openDialogEdit(value.item);
            else if (value.type == 'restore')
        this.openDialogRestore(value.item, "");
        this.urlOfMatListClicked=value.item.route;
        }); //this event is invoked when SOA Federal in menu is clicked from federal_menu_component.html
  }


  getClass(num){
    if(num==1)
      return 'class1'
    else
      return 'class2'
  }
  openDialog(type,item): void {
    let parent = item?item.displayName:'';
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
      data: {folder: '',parentFolder:parent,mode:type}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.folderName = result;
      if(result)
        this.createNew(type,item);
    });
  }

  openDialogEdit(item): void {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
      data: {folder: item.displayName,parentFolder:item.route,mode:'edit'}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.folderName = result.trim();
      if(this.navService.checkValidity(this.folderName))
      {
        this.commonService.updateNavItem(item.id,this.folderName);

      }

    });
  }
  openDialogDelete(item){
    if(item.type.toLowerCase() == 'folder' && item?.children.filter(x=>x.articleID !=null).length>0 )
    {
      this.isEmptyFolder=false;
      //this.isEmptyFile=false;
    }
    else{
      this.isEmptyFolder=true;
    }
    if(item.type.toLowerCase() == 'file' && item.articleID !=null || item.articleID !=undefined)
    {
      this.isEmptyFile=false;
    }
    else{
      this.isEmptyFile=true;
    }
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
      data: {folder:item.displayName,parentFolder:'',mode:'delete',navItemType:item.type,isEmptyFolder:this.isEmptyFolder,isEmptyFile:this.isEmptyFile}

    });

    dialogRef.afterClosed().subscribe(result => {
      if(result)
          this.commonService.deleteNavItem(item)
    });

  }
  openDialogRestore(item, duplictatefileNameMessage): void {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {

      data: { folder: (duplictatefileNameMessage == undefined || duplictatefileNameMessage == "")? item.displayName:this.folderName, parentFolder: item.route, mode: 'restore', item: item, duplictatefileNameMessage: duplictatefileNameMessage,activeFilesCount:(item.type=='Folder' && item?.children.filter(x=>x.articleID !=null).length>0)?true:false }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.folderName = result.trim();
      if (this.navService.checkValidity(this.folderName))
        this.checkFolderNameExists(item,this.folderName);
    });
  }
  checkFolderNameExists(item,folderName) {
    let folderId = item.id;

    //let folderName = this.folderName;
    let redirectUrl;
    item.route =  item.route.toString().replace(item.route.split('/')[1],folderName.toLowerCase().split(' ').join('_'))
    this.commonService.checkFolderNameExists(folderId, folderName).subscribe(
      data => {
        this.result = data;
        if (this.result.Status == "Success") {
          /* alert("Hello")*/
          this.commonService.updateNavItemForRestoring(folderId, folderName);
          this.commonService.getNavList();

        item.displayName=folderName;
        //  console.log(item.route.toString().substring(0, item.route.toString().lastIndexOf('/')) + '/edit/' + item.route.toString().split('/')[3]);
        if(item.type=='File')
          if(item.articleID){this.router.navigate([item.route.toString().substring(0, item.route.toString().lastIndexOf('/')) + '/edit/' + item.route.toString().split('/')[3]]);}
          else{this.router.navigate([item.route.toString().substring(0, item.route.toString().lastIndexOf('/')) + '/create']);}

          else if(item.type=='Folder')
          {
            //this.navService.triggerFunction("restore",item);
            if(localStorage.getItem("folderItem") !="" || localStorage.getItem("folderItem") !=undefined)
            {
            localStorage.setItem("folderItem","");
            localStorage.setItem("folderItem",JSON.stringify(item));
            }
            else{
              localStorage.setItem("folderItem",JSON.stringify(item));
            }
            // this.router.navigate(['restoreFolder']);
            //this.router.navigateByUrl('/restoreFolder?id='+item.id);
            // this.router.navigate(['restoreFolder'])
            // .then(() => {
            //   window.location.reload();
            // });
            //this.navService.triggerFunction('restore',item);
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
              this.router.navigate(['restoreFolder']);
          });
          }

        }
        else {
          //this.commonService.setNotification("File Name already taken. Please rename to proceed further.", "Error");
          if(item.type=='File')
          this.openDialogRestore(item, "* File Name already taken.");
          else if(item.type=='Folder')
          this.openDialogRestore(item, "* Folder Name already taken.");
        }
      }
    )
  }
  ngOnInit(){

    this.route.queryParams.subscribe((params: any) => {
      if (Object.keys(params).length) { //params like accessToken and expiresIn
        this.processingLogin=true;
      }
      else
        this.processingLogin=false;
    });
    [].forEach.call(document.querySelectorAll("[data-toggle=\"dds__form-validation\"]"), function(element) {
      new UIC.Form(element, {validate: "true"});
    });
    [].forEach.call(document.querySelectorAll("[data-toggle=\"dds__modal\"]"), function(element) {
      new UIC.Modal(element, {
          backdrop: 'static'
      });
    });

    if(localStorage.getItem('authToken')){
      this.loadNavDetails();
    }
    else{
      this.commonService.gettoken('').subscribe(data=>{
        this.authService.setAuthToken(data.authToken)
        this.loadNavDetails();
      });

    }


  }
  loadNavDetails(){
    this.authService.itemValue.subscribe((nextValue) => {
      this.RoleName=nextValue.RoleName;
      this.commonService.getNavList();

  })
  this.navSub=this.commonService.getNavListUpdateListener().
     subscribe((navItems:NavList[])=>{
       this.navItems=navItems;
       this.navService.navItems=navItems

      if(this.RoleName === this.Moderator || this.RoleName === this.Publisher){
        this.navItems.unshift(
          {
              displayName:'Dashboard',
              route:'portal',
              id:'',
              children:[]
          }
        )
      }
        this.navItems.unshift(
          {
              displayName:'Home',
              route:'home',
              id:'',
              children:[]
          }
        )
        console.log(this.navItems)

   });

        if(this.router.url.includes('new_folder') ){
          this.mode="new_addition"
      }
      this.route.queryParams.subscribe((params: any)=>{
        if(Object.keys(params).length){
        this.parameters=params;
        this.authService.setSession(this.parameters);
        this.commonService.fetchUserDetails();
        }
      })
  }
  newFolder(){
    this.urlOfMatListClicked='';
    this.openDialog('new_folder',null);
  }
  refresh(){
    this.commonService.getNavList();
  }
  createNew(type,item){
    this.prevUrl = item && item.route;
    this.folderName=this.folderName.trim();
    if(this.navService.checkValidity(this.folderName))
      {
        if(this.prevUrl)
          this.newUrl= this.prevUrl +'/'+ this.folderName.toLowerCase().split(' ').join('_');
        else
          this.newUrl = this.folderName.toLowerCase().split(' ').join('_');
        if(type=="new_folder")
            this.commonService.addNavItem(this.folderName,0,"Folder",this.newUrl);
        else if(type=="new_file")
            this.commonService.addNavItem(this.folderName,item.id,"File",this.newUrl);
     }
  }

  drop(event: CdkDragDrop<string[]>) {
    console.log("event",event);
    if(!event.container.id){ //Home & Dashboard are not droppables
      return;
    }
    if (event.previousContainer === event.container) {
      // moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      return; //restrict reordering inside a folder
    }
    else {
      transferArrayItem(event.previousContainer.data,
                        event.container.data,
                        event.previousIndex,
                        event.currentIndex);
    }

    let oldFolderId=event.previousContainer.id;
    let newFolderId=event.container.id;
    let file=event.container.data[event.currentIndex];
    let fileId = file['id'];
    let fileName = file['displayName'];
    let fileType = file['type'];
    let routePath = file['route'];
    console.log("Updated Navitems",this.navItems);
    console.log("oldFolderId:",oldFolderId,"\nnewFolderId:",newFolderId,"\nFile:",File,"\nFileId:", fileId);

    // api call
    this.loading=true;
    this.commonService.moveFiles(fileName, fileType, newFolderId, fileId).subscribe(
      result=>{
        if(result.Status=="Failure"){
          this.commonService.setNotification("Something went wrong! Please try again in some time.","Error");
          this.router.navigateByUrl('/home');
          return;
        }
        this.commonService.getNavList();//Refresh Navlist
        let targetFolderRoute = this.navItems.find(folder => folder.id === parseInt(newFolderId)).route;

        let droppedNavPath = `/${targetFolderRoute}/${fileName}/article/${fileId}`;
        let routePathArray = routePath.split('/');
        routePathArray[0] = targetFolderRoute;
        let modifiedDroppedPath = routePathArray.join('/');
        this.router.navigateByUrl(modifiedDroppedPath);

        this.loading=false;

        this.commonService.setNotification("File moved successfully","Success");
      }
    )
  }

  ngAfterViewInit() {
    this.navService.appDrawer = this.appDrawer;
  }
  @ViewChild('appDrawer') appDrawer: ElementRef;

}

@Component({
  selector: 'dialog-overview-example-dialog',
  templateUrl: 'sidenav-dialog.modal.html',
  styleUrls: ['./sidenav.component.scss'],
})
export class DialogOverviewExampleDialog {
  clicked:boolean=false;
  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,private router:Router,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,private commonService:CommonService,public dialog: MatDialog) {}
  toggle(event){
    this.clicked=!this.clicked;
  }
  onNoClick(): void {
    this.dialogRef.close();
    this.router.navigate(['/']);
    }
    filesChecked = [];
    selectedIds = [];
    selectedFiles = [];
    filesIdsNamesList = [];
    duplicateFoldersList = [];
    duplicatefolderErrorsMessage ="<ul>";
    isSelectAllChecked :boolean =false;
    noFilesChekedError:any = "";
    isNoFilesCheked:boolean = false;
    result:any;
    loading:any;
    fileNameErrorMessage:any;
    isInvalidRequest:any = false;
    duplicateChecks=[];
    onlyoneFileChecked : boolean = false;
    filteredItem:any;
    emptyParentItemArray:any=[];
    //Folder restoring
   updateCheckedFileOptions(children, event, item) {
    // this.onlyoneFileChecked = true;
        if (event.target.checked)
        {
          this.filesChecked.push({ FolderId: children.id, Name: children.displayName,articleId:item.articleID==null?0:item.articleID});

            if(this.filesChecked.length == item.children.length)
            {
              this.isSelectAllChecked = true;
            }
            else{
              this.isSelectAllChecked = false;
            }
          }
        else{
          this.filesChecked = this.filesChecked.filter( x=> x.FolderId !=children.id);
          this.isSelectAllChecked = false;
        }

     }


  SelectAllFileOptions(item, event) {

    /*this.selectedIds = item.children.map(({ id }) => id, ({ displayName }) => displayName);*/
    if(this.filesChecked.length>0)
    {
      this.filesChecked = [];
      this.filesIdsNamesList = [];
    }
    //item = item.filter(x=>x.articleID!=null);
    this.selectedIds = item.filter(x=>x.articleID!=null).map(({ id }) => id);
    //this.selectedIds = item.map(({ id }) => id);
    if (event.target.checked){
      this.isSelectAllChecked = true;
      this.onlyoneFileChecked = true;
      for (let i = 0; i < this.selectedIds.length; i++) {
        // this.filesIdsNamesList[this.selectedIds[i]] = this.selectedFiles[i];
        this.filteredItem= item.filter(x =>x.id ==this.selectedIds[i]);
        this.filesChecked.push({ FolderId: this.filteredItem[0]["id"], Name: this.filteredItem[0]["displayName"],articleId:this.filteredItem[0]["articleID"]==null?0:this.filteredItem[0]["articleID"]});
       // console.log(item[i]["displayName"]);

      }
    }
    else {
      this.isSelectAllChecked = false;
      this.onlyoneFileChecked = false;
      this.filesChecked = [];
      this.filesIdsNamesList = [];
    }

  }


  RestoreFolder(item)
  {
    this.loading = true;
    //console.log(document.querySelectorAll('.dds__form-check'));
    if(item.children.length>0)
    {
    if(document.querySelectorAll('.dds__form-check').length<=0)
    {
      this.isInvalidRequest =true;
      this.fileNameErrorMessage = "* No Files/Articles created to restore the folder.";
return false;
    }
    document.getElementById("fileError").innerHTML ="";
    if (this.filesChecked.length > 0) {
     this.duplicateChecks = this.filesChecked.map(x => x["Name"]).filter((value, index, self) => self.indexOf(value) === index);
     if(this.duplicateChecks.length == this.filesChecked.length)
     {
      this.isNoFilesCheked = false;
      this.loading = true;
      this.commonService.checkFolderNameExists(item.id,item.displayName).subscribe(
        data => {
          this.result = data;
          if (this.result.Status == "Success") {
            /* alert("Hello")*/
            this.commonService.updateNavItemForRestoring(item.id, item.displayName);
            this.checkFileNamesForRestoringFolder(this.filesChecked,item);

          }
        else{
          this.loading = false;
          this.isInvalidRequest= true;
          this.fileNameErrorMessage = "* Folder name already taken.";

          //this.openDialogRestore(item,"* Folder name already taken.")
        }});
      }
      else{
        this.isNoFilesCheked = true;
      this.noFilesChekedError = "* All files names should be unique.";
      return false;
      }
    }
    else
    {
      this.isNoFilesCheked = true;
      this.noFilesChekedError = "* Please Select atleast one file to restore.";
      return false;
  }
}
else{
  this.commonService.checkFolderNameExists(item.id,item.displayName).subscribe(
    data => {
      this.result = data;
      if (this.result.Status == "Success") {
        /* alert("Hello")*/
        this.emptyParentItemArray.push({ FolderId: item.id, Name: item.displayName,articleId:1});
        this.commonService.ActivateFolderForRestoring(item.id,item.displayName);
        this.dialogRef.close();
        this.commonService.setNotification("Folder Restored Succefully","Success");
              //this.checkFileNamesForRestoringFolder(this.filesChecked,item);

      }
    else{
      this.loading = false;
      this.isInvalidRequest= true;
      this.fileNameErrorMessage = "* Folder name already taken.";

      //this.openDialogRestore(item,"* Folder name already taken.")
    }});
}

  }
    checkFileNamesForRestoringFolder(inputData: Array<any>,item) {
      this.filesChecked =[];
          for (let i = 0; i <= inputData.length - 1; i++) {
        // console.log(inputData[i]["FolderId"],item.children.filter(x =>x.id == inputData[i]["FolderId"]).length);

            if(item.children.filter(x =>x.id == inputData[i]["FolderId"]).length>0)
            {
              this.filteredItem= item.children.filter(x =>x.id == inputData[i]["FolderId"]);
              // console.log(this.filteredItem);
            this.filesChecked.push({ FolderId: this.filteredItem[0]["id"], Name: this.filteredItem[0]["displayName"],articleId:this.filteredItem[0]["articleID"]==null?0:this.filteredItem[0]["articleID"]});
                }
              }
                inputData = this.filesChecked;
      this.commonService.checkRestoreFolderFilesNameExists(inputData)
        .subscribe((result) => {
         // console.log(result);
          let data=result.data;
          if (result["Status"] == "Failure") {
            this.duplicateFoldersList = data.filter(x => x.IsAvailable != 1).map(x => x.Name);;
            if (this.duplicateFoldersList.length > 0) {
              for (let i = 0; i <= this.duplicateFoldersList.length - 1; i++) {
                this.duplicatefolderErrorsMessage += "<li>" + this.duplicateFoldersList[i] + " file name already taken.</li>";
              }
              this.duplicatefolderErrorsMessage += "</ul>"
              document.getElementById("fileError").innerHTML = this.duplicatefolderErrorsMessage;
            }
            //this.sidenavComponet.openDialogRestore(item, this.duplicatefolderErrorsMessage);
            this.loading = false;
            this.isInvalidRequest= true;
           // this.fileNameErrorMessage = this.duplicatefolderErrorsMessage;
            return false;
          }
          else {
            for (let i = 0; i <= inputData.length - 1; i++) {

            this.commonService.updateNavItemForRestoring(inputData[i]["FolderId"], inputData[i]["Name"]);
                    }
          this.commonService.updateArticleItemForRestoring(inputData);

            //console.log(data);
            this.loading = false;
            this.dialogRef.close();

            return true;


          }

              },
        (error) => {
          this.loading = false;
          this.commonService.setNotification("Error! Please try after some time.", "Error");
          this.router.navigate(['/']);
        }
        );
    }
}
